<template>
  <div class="billing-wrapper">
    <form method="post" @submit.prevent="subscriptionPlan">
      <div class="billing-container">
        <h3 class="section-title">
          {{ label.get("select_plan") }}
        </h3>
        <p>
          {{ label.get("subscription_plans_description") }}
        </p>
        <div class="plan-options">
          <div
            v-for="(plan, idx) in plans"
            :key="idx"
            class="option"
            :class="{ selected: selectedPlan && plan.id === selectedPlan.id }"
          >
            <div class="radio-wrap">
              <b-form-radio
                v-model="selectedPlan"
                name="plan"
                @change="selectPlan(plan)"
              >
                <div class="plan">
                  <h3 class="plan-title">
                    {{ plan.title }}
                  </h3>
                  <span class="disclaimer-label">
                    {{ plan.disclaimer }}
                  </span>
                </div>
                <div class="pricing">
                  <h3>${{ plan.priceLabel }}</h3>
                  <span>{{ label.get("user_month") }}</span>
                </div>
              </b-form-radio>
            </div>
          </div>
          <span v-show="error" class="error">{{
            label.get("subscription_plans_select_plan_before")
          }}</span>
        </div>
        <div class="manage-seats">
          <i class="atto atto-team" />
          <div class="manage">
            <h4
              @click="manageSeats"
              v-html="
                label.get('subscription_plans_manage_seats_users', {
                  totalUsers: totalUsers,
                })
              "
            />
            <p>
              {{
                label.get(
                  "subscription_plans_you_currently_have_total_users_description",
                  { totalUsers: totalUsers }
                )
              }}
            </p>
          </div>
        </div>
      </div>
      <div class="billing-wrap">
        <div class="billing-sidebar">
          <h3 class="sidebar-title">
            {{ label.get("order_summary") }}
          </h3>
          <hr class="break-line" />
          <div class="field-row title-field" style="margin-bottom: 27px;">
            <h4 v-if="selectedPlan" class="sidebar-subtitle">
              {{ selectedPlan.title }} {{ label.get("billing") }}
            </h4>
            <h4 v-if="!selectedPlan" class="sidebar-subtitle">
              {{ label.get("billing_plan") }}
            </h4>
          </div>
          <div class="field-row">
            <h5 class="field-label">
              {{ label.get("total_users") }}
            </h5>
            <span class="value">{{ totalUsers }}</span>
          </div>
          <div class="field-row">
            <h5 class="field-label">
              {{ label.get("subscription_price_per_user") }}
            </h5>
            <span v-if="selectedPlan" class="value"
              >${{ selectedPlan.pricePerUser }}/{{ planLabel }}</span
            >
            <span v-else class="value">$ -</span>
          </div>
          <div class="field-row">
            <h5 class="field-label">
              {{ label.get("subscription_subtotal") }}
            </h5>
            <span v-if="selectedPlan" class="value">${{ subTotal }}</span>
            <span v-else class="value">$ -</span>
          </div>
          <div class="field-row">
            <h5 class="field-label">
              {{ label.get("subscription_tax") }}
            </h5>
            <span class="value">$ -</span>
          </div>
          <!--<div class="field-row">
            <h5 class="field-label">
              Subtotal
            </h5>
            <span
                    v-if="selectedPlan"
                    class="value"
            >${{ selectedPlan.pricePerUser }}/{{ planLabel }}</span>
            <span
                    v-else
                    class="value"
            >$ -</span>
          </div>
          <div class="field-row discount">
            <h5 class="field-label">
              Atto Discount
            </h5>
            <span
                    v-if="selectedPlan"
                    class="value"
            >${{ selectedPlan.pricePerUser }}/{{ planLabel }}</span>
            <span
                    v-else
                    class="value"
            >$ -</span>
          </div>-->
          <div class="field-row total">
            <h5 class="field-label">
              {{ label.get("subscription_total_amount") }}
            </h5>
            <span v-if="selectedPlan" class="value"
              >${{ totalAmount }}/{{ planLabel }}</span
            >
            <span v-else class="value">$ -</span>
          </div>
          <hr class="break-line bottom" />
          <button class="atto-btn submit">
            {{ label.get("subscription_go_to_payment") }}
          </button>
        </div>
      </div>
    </form>
    <manage-team-component v-if="manageMembers" :members="members" />
    <verify-email-component v-if="showVerifyEmail" />
  </div>
</template>

<script>
import ManageTeamComponent from "../../../shared/components/ManageTeamComponent";
import MemberService from "../../settings/services/MemberService";
import VerifyEmailComponent from "../../../shared/components/VerifyEmailComponent";

export default {
  name: "SubscriptionPlansComponent",
  components: {
    VerifyEmailComponent,
    ManageTeamComponent,
  },
  data: function() {
    return {
      plans: [
        {
          title: this.label.get("annual"),
          disclaimer: this.label.get("subscription_plans_disclaimer_annual", {
            price: 95.40,
          }),
          id: "annual_95",
          pricePerUser: 95.40,
          priceLabel: 7.95,
          checked: false,
        },
        {
          title: this.label.get("monthly"),
          disclaimer: this.label.get("subscription_plans_disclaimer_monthly", {
            price: 9.95,
          }),
          id: "monthly_9",
          pricePerUser: 9.95,
          priceLabel: 9.95,
          checked: false,
        },
      ],
      selectedPlan: null,
      planLabel: "",
      manageMembers: false,
      members: [],
      totalUsers: 0,
      subTotal: 0,
      totalAmount: 0,
      error: false,
      showVerifyEmail: false,
    };
  },
  created() {
    if (
      this.$store.state.subscribed ||
      !this.$store.state.permission.canAccessBilling
    ) {
      this.$router.push("/activity");
    } else {
      this.getMembers();
    }
  },
  mounted() {
    this.$root.$on("onManageTeamClose", this.onManageTeamClose);
    this.$root.$on("onHideVerifyEmail", this.onHideVerifyEmail);

    const reloadParam = this.$route.query.r;
    if (reloadParam !== undefined) {
      localStorage.setItem("verified_email", "true");
    }
  },
  beforeDestroy() {
    this.$root.$off("onManageTeamClose");
    this.$root.$off("onHideVerifyEmail");
  },
  methods: {
    getMembers() {
      this.$store.commit("showLoading");
      const stateMembers = this.$store.state.members;
      MemberService.getMembers()
        .then((data) => {
          this.members = data.map((item) => {
            item.changed = false;
            item.deleted = false;
            item.deleting = false;
            item.confirm_delete = false;
            const member = stateMembers.find((member) => {
              return member.id === item.id;
            });
            if (member) {
              item.avatar = member.avatar;
              item.initials = member.initials;
            }
            return item;
          });
          this.totalUsers = this.members.length;
          this.$store.commit("hideLoading");
          localStorage.setItem("quantity", this.totalUsers);
        })
        .catch((error) => {});
    },
    subscriptionPlan: function() {
      if (this.selectedPlan === null) {
        this.error = true;
        return;
      }

      if (!this.$store.state.user.verified_email) {
        this.showVerifyEmail = true;
        return;
      }

      this.$router.push("/subscription/billing-information");
    },
    selectPlan: function(plan) {
      this.selectedPlan = plan;
      this.totalAmount = (this.totalUsers * this.selectedPlan.pricePerUser).toFixed(2);
      this.subTotal = this.totalAmount;
      this.planLabel =
        this.selectedPlan.id === "monthly_9"
          ? this.label.get("month")
          : this.label.get("year");
      localStorage.setItem("plan", this.selectedPlan.id);
      this.error = false;
    },
    manageSeats: function() {
      this.manageMembers = true;
    },
    onManageTeamClose(reloadData = false) {
      this.manageMembers = false;
      this.totalUsers = this.members.length;
      if (this.selectedPlan !== null) {
        this.totalAmount = this.totalUsers * this.selectedPlan.pricePerUser;
        this.subTotal = this.totalAmount;
      }
      localStorage.setItem("quantity", this.totalUsers);
      if (reloadData) {
        this.getMembers();
      }
    },
    onHideVerifyEmail() {
      this.showVerifyEmail = false;
    },
  },
};
</script>

<style lang="scss" scoped>
main.billing {
  .billing-sidebar {
    .field-row {
      &.discount {
        background-color: rgba(6, 184, 183, 0.1);
        height: 40px;
        padding: 8px;

        h5 {
          &.field-label {
            color: #00b9cb;
          }
        }
        span {
          &.value {
            color: #00b9cb;
          }
        }
      }
    }
  }
}
.plan-options {
  display: flex;
  flex-direction: column;

  .option {
    margin-bottom: 20px;
    border: 2px solid #efefef;
    cursor: pointer;
    -webkit-transition: ease all 0.15s;
    -moz-transition: ease all 0.15s;
    -ms-transition: ease all 0.15s;
    -o-transition: ease all 0.15s;
    transition: ease all 0.15s;

    .radio-wrap {
      width: 100%;

      .custom-control-label {
        display: flex;
        width: 100%;
        flex-direction: row;
        align-items: center;
      }
    }
  }

  .error {
    font-family: "Roboto", sans-serif;
    font-size: 14px;
    font-weight: 500;
    color: #e05656;
    margin-left: 82px;
    margin-bottom: 10px;
    margin-top: -5px;
  }
}

.manage-seats {
  margin-top: 21px;
  padding-left: 40px;
  display: flex;
  flex-direction: row;

  i {
    width: 24px;
    height: 24px;
    font-size: 13px;
    margin-right: 18px;
    margin-top: 4px;
    display: flex;
    align-items: center;
  }

  .manage {
    display: flex;
    flex-direction: column;

    h4 {
      font-size: 1.125rem;
      margin-bottom: 6px;
      line-height: 2rem;
      font-weight: 500;
      color: #00b9cb;
      font-family: "Roboto", sans-serif;
      cursor: pointer;
      display: inline-flex;
      align-items: center;

      br.mobile {
        display: none;
      }

      i {
        color: #c7c7c7;
        font-size: 13px;
        justify-content: center;
        margin-left: 10px;
        margin-top: 0;
        -webkit-transition: ease all 0.15s;
        -moz-transition: ease all 0.15s;
        -ms-transition: ease all 0.15s;
        -o-transition: ease all 0.15s;
        transition: ease all 0.15s;
      }

      &:hover {
        color: #06a09f;

        i {
          color: #262626;
        }
      }
    }

    p {
      margin-bottom: 20px;
      max-width: 400px;
    }
  }
}

@media (max-width: 768px) {
  main.billing .billing-container > .section-title,
  main.billing .billing-container > p {
    margin-bottom: 30px;
  }

  .plan-options {
    .option {
      flex-wrap: wrap;
      align-items: flex-start;

      .plan {
        width: 100%;
        padding-left: 40px;

        span {
          position: relative;
          left: auto;
          bottom: auto;
          display: inline-block;
          margin-top: 4px;
        }
      }

      .radio-wrap {
        &:hover {
          cursor: pointer;
        }
      }

      .pricing {
        width: 100%;
        margin-top: 6px;
        padding-left: 40px;

        h3 {
          margin-right: 8px;
        }
      }
    }
  }

  .manage-seats {
    padding-left: 25px;
    .manage {
      h4 {
        br.mobile {
          display: block;
        }

        i {
          margin-top: 4px;
          margin-right: 0;
        }
      }

      p {
        margin-bottom: 0;
      }
    }
  }
}

@media only screen and (max-width: 768px) and (orientation: landscape) {
  main.billing {
    .billing-wrapper {
      form {
        flex-direction: column;
        align-items: center;
      }
      .billing-container {
        width: 66.66667%;
        margin-bottom: 24px;
      }

      .billing-wrap {
        width: 66.66667%;
      }
    }
  }

  .manage-seats {
    .manage {
      h4 {
        br.mobile {
          display: none;
        }
      }
    }
  }
}
</style>
